module.exports = __webpack_public_path__ + "img/online_team_meeting_.279a4ce7.svg";